var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user && _vm.user.onlineType == 'GDI')?_c('p',{staticClass:"mainTxt"},[_vm._v("GDI")]):_c('p',{staticClass:"mainTxt"},[_vm._v("PGDI")])])
}
var staticRenderFns = []

export { render, staticRenderFns }